export const WEBSOCKET_URL = 'wss://v1vnafb0n9.execute-api.us-east-1.amazonaws.com/dev';
// export const WEBSOCKET_URL = 'ws://localhost:3001';
// export const WEBSOCKET_URL = 'wss://unf7xxcqz5.execute-api.us-east-1.amazonaws.com/prod';
// export const WEBSOCKET_URL = 'wss://026f9jucli.execute-api.us-east-1.amazonaws.com/marc'
export const API_URL = 'https://d8yczlp0qa.execute-api.us-east-1.amazonaws.com/dev';